var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelectionEditorIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 0.666626L5.33203 2.66663M10.6654 0.666626V2.66663M11.332 5.33329H4.66536M7.73203 14.6666H8.26536C10.5056 14.6666 11.6257 14.6666 12.4813 14.2307C13.234 13.8472 13.8459 13.2352 14.2294 12.4826C14.6654 11.6269 14.6654 10.5068 14.6654 8.26663V7.73329C14.6654 5.49308 14.6654 4.37298 14.2294 3.51733C13.8459 2.76468 13.234 2.15276 12.4813 1.76927C11.6257 1.33329 10.5056 1.33329 8.26537 1.33329H7.73203C5.49182 1.33329 4.37172 1.33329 3.51607 1.76927C2.76342 2.15276 2.1515 2.76468 1.76801 3.51733C1.33203 4.37298 1.33203 5.49308 1.33203 7.73329V8.26663C1.33203 10.5068 1.33203 11.6269 1.76801 12.4826C2.1515 13.2352 2.76342 13.8472 3.51607 14.2307C4.37172 14.6666 5.49182 14.6666 7.73203 14.6666Z",
    stroke: "#EDC533",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelectionEditorIcon);
export default ForwardRef;